import clsx from 'clsx';
import React, { forwardRef, HTMLProps, PropsWithChildren } from 'react';
import { Stack, StackProps } from '../../stack';
import classes from './card-content.module.scss';

export type CardContentProps = PropsWithChildren & Omit<HTMLProps<HTMLDivElement>, 'ref'> & StackProps;

/**
 * A React component used to render the content area of a card.
 *
 * This component utilizes a stack layout to organize its children elements in a columnar fashion
 * and supports additional customization through the provided props.
 */
export const Content = forwardRef<HTMLDivElement, CardContentProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Stack
        crossAxis="stretch"
        {...props}
        ref={ref}
        direction="column"
        className={clsx(classes.root, className, 'card-content-component')}
      >
        {children}
      </Stack>
    );
  }
);

Content.displayName = 'Card.Content';